// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rapidash_galar: PokeData = {
  "id": 10163,
  "name": "rapidash-galar",
  "height": 17,
  "weight": 800,
  "base_experience": 175,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FAIRY
  ],
  "api_moves": [
    "stomp",
    "tackle",
    "take-down",
    "tail-whip",
    "growl",
    "psybeam",
    "confusion",
    "psychic",
    "agility",
    "quick-attack",
    "megahorn",
    "healing-wish",
    "psycho-cut",
    "heal-pulse",
    "fairy-wind",
    "dazzling-gleam"
  ],
  "moves": [
    "tackle",
    "growl",
    "psychic",
    "quick-attack",
    "healing-wish",
    "dazzling-gleam",
    "synchronize",
    "hyper-voice",
    "play-rough",
    "psychic-fangs",
    "spirit-break",
    "psywave",
    "starfall"
  ],
  "evolution_chain": {
    "id": 32,
    "item": null,
    "species": [
      {
        "name": "ponyta",
        "order": 83,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "rapidash",
        "order": 84,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 77,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 102,
    "speed": 153,
    "ability_power": 145
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "galar"
} as const;
